import emptyTableIllustration from './empty-table-results.png';
import styles from './style.module.css';

export const TableEmptyState = () => (
  <div className={styles.emptyState}>
    <img
      className={styles.illustration}
      src={emptyTableIllustration}
      alt=""
      width={1774}
      height={887}
    />
    <div className={styles.copy} role="status" aria-live="polite">
      <h2 className={styles.title}>По выбранным фильтрам ничего не нашлось</h2>
      <p className={styles.description}>
        Попробуйте изменить параметры поиска или выбрать другой период
      </p>
    </div>
  </div>
);
